var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('navigation-menu'),_c('context-menu-home'),_c('span',{staticClass:"text-h6 text-md-h5 text-lg-h4 font-weight-light d-flex justify-center mt-md-3 mt-lg-6 mb-lg-3"},[_vm._v("Vítej ve zdrojích In-Life")]),_c('search-bar'),_c('resource-container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }